import { TFunction } from "react-i18next";

import * as icons from "icons";
import * as models from "models";

export interface NavigationItem {
  label: string;
  to: string;
  exact?: boolean;
  icon: React.ReactNode;
}

export interface GetNavigationItemsOptions {
  user?: models.Profile | null;
}

export const getNavigationItems = (
  t: TFunction<"common", "navigation_items">,
  { user }: GetNavigationItemsOptions,
): NavigationItem[] => [
  {
    label: t("dashboard"),
    to: "",
    exact: true,
    icon: <icons.Dashboard />,
  },
  ...(user?.is_enterprise
    ? []
    : [
        {
          label: t("prepaid_packages"),
          to: "packages",
          exact: true,
          icon: <icons.Packages />,
        },
      ]),
  {
    label: t("documentation"),
    to: "docs",
    exact: true,
    icon: <icons.Document />,
  },
  {
    label: t("account"),
    to: "account",
    exact: true,
    icon: <icons.User />,
  },
];
